module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex align-center inline-checkbox-outer"
  }, [_c('label', {
    staticClass: "input--checkbox"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.isChecked
    },
    on: {
      "change": _vm.toggle
    }
  }), _vm._v(" "), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "30px",
      "height": "30px",
      "version": "1.1"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('rect', {
    attrs: {
      "x": "5",
      "y": "5",
      "width": "20",
      "height": "20",
      "rx": "3"
    }
  }), _vm._v(" "), _c('polyline', {
    attrs: {
      "points": "28 3 15.1266569 17 10 11.8756235"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input__inline-label"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), (_vm.required) ? _c('span', {
    staticClass: "input__asterisk"
  }, [_vm._v("*")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48531ed0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputCheckbox.vue
// module id = 599
// module chunks = 0